module.exports = __webpack_public_path__ + "img/software1.244695d0.jpg";